import React from 'react';
import { Helmet } from 'react-helmet-async';

import i18n from '@/settings/i18n';

// Zendeskの管理画面で発行されるウィジェットタグのURL
const ZENDESK_SNIPPET_URL = 'https://static.zdassets.com/ekr/snippet.js';
// Zendeskの日本語ウィジェットのキー
const ZENDESK_JA_KEY = '9cc960b7-d2ac-4b84-a8cd-1c998caed107';
// Zendeskの英語ウィジェットのキー
const ZENDESK_EN_KEY = 'aaf0d177-2bad-4415-a893-724290a48053';

export const ZendeskWidget: React.FC = () => {
  const key = i18n.languages[0] === 'ja' ? ZENDESK_JA_KEY : ZENDESK_EN_KEY;
  const scriptSrc = `${ZENDESK_SNIPPET_URL}?key=${key}`;

  return (
    <Helmet>
      <script>{`
      // "ze-snippet"がすでにあったら、以下の処理をskipする
      if (!document.getElementById("ze-snippet")) {
        var script = document.createElement("script");

        script.id = "ze-snippet";
        script.src = "${scriptSrc}";
        script.setAttribute("charset", "utf-8");
        script.onload = function() {
          if ('${i18n.languages[0]}' === 'ja') {
            // ja use new API: https://developer.zendesk.com/api-reference/widget-messaging/web/core/#set-locale
            window.zE('messenger:set', 'locale', 'ja');
          } else {
            window.zE('webWidget', 'setLocale', 'en');
          }
          window.zESettings = { webWidget: { answerBot: { search: { labels: ['Answerbot用記事（管理者）'] } } }};
        };

        document.getElementsByTagName("body")[0].appendChild(script);
      }
    `}</script>
    </Helmet>
  );
};
